// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import React from 'react'
import {Link} from 'react-router-dom'

import CustomDropdown from '../../DropDown'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import './navigation.css'

export const ANALYTICS_PATH = 'analytics'
export const SERVICES_PATH = 'services'
export const MULTIDRM_ACTIVITY_PATH = 'multi-drm-activity'
export const IPTV_ACTIVITY_PATH = 'iptv-activity'
export const OTT_ACTIVITY_PATH = 'ott-activity'
export const API_ACTIVITY_PATH = 'api-activity'


export function analyticsNavOptions (location) {
  let splittedLocation = location.split('/')
  let ddTriggerActive = splittedLocation[2]
  let ddItemActive = splittedLocation[3]

  return (
    <ul className='analyticsNav'>
      <li className='nav-item'>
        <CustomDropdown dropdownTrigger={<>Service Insight <ExpandMoreIcon/></>} dropdownTriggerClassname={ddTriggerActive === SERVICES_PATH ? 'active' : ''}>
          <div className='row'>
            <div className='col-md-12'>
              <ul>
                <li className='title services'> Services </li>
                <li className={`item ${ddItemActive === IPTV_ACTIVITY_PATH ? 'active' : ''}`}>
                  <Link className='dropdown' to={`/${ANALYTICS_PATH}/${SERVICES_PATH}/${IPTV_ACTIVITY_PATH}/`}>VCAS IPTV Activity</Link>
                </li>
                <li className={`item ${ddItemActive === OTT_ACTIVITY_PATH ? 'active' : ''}`}>
                  <Link className='dropdown' to={`/${ANALYTICS_PATH}/${SERVICES_PATH}/${OTT_ACTIVITY_PATH}/`}>VCAS OTT Activity</Link>
                </li>
                <li className={`item ${ddItemActive === MULTIDRM_ACTIVITY_PATH ? 'active' : ''}`}>
                  <Link className='dropdown' to={`/${ANALYTICS_PATH}/${SERVICES_PATH}/${MULTIDRM_ACTIVITY_PATH}/`}>VCAS Multi DRM Activity</Link>
                </li>
                <li className={`item ${ddItemActive === API_ACTIVITY_PATH ? 'active' : ''}`}>
                  <Link className='dropdown' to={`/${ANALYTICS_PATH}/${SERVICES_PATH}/${API_ACTIVITY_PATH}/`}>VCAS API Activity</Link>
                </li>
              </ul>
            </div>
          </div>
        </CustomDropdown>
      </li>
    </ul>
  )
}
